/** Money for the orders table. Two decimals, unlike the whole-dollar catalog. */
export const formatMoney = (n: number | null | undefined, currency = 'USD'): string => {
  if (!Number.isFinite(Number(n))) return '—';
  return Number(n).toLocaleString(undefined, {
    style: 'currency',
    currency,
    maximumFractionDigits: 2,
  });
};

/** A timestamp reduced to the ISO day a date input expects. */
export const toDateInputValue = (value?: string | null): string => {
  if (!value) return '';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '';
  return d.toISOString().slice(0, 10);
};

/** "Order Date" means `Order.createdAt` — flattened by the export, nested otherwise. */
export const orderDateOf = (row: any): string | undefined =>
  row?.orderCreatedAt || row?.order?.createdAt;

/**
 * The carrier cell only has room for the company name, so the tooltip carries
 * the dispatch details staff would otherwise open the manage dialog to read.
 */
export const carrierTooltip = (row: {
  carrier?: {
    companyName: string;
    phone?: string | null;
    dotNumber?: string | null;
    mcNumber?: string | null;
  } | null;
}): string | null => {
  if (!row.carrier) return null;

  const details = [
    row.carrier.phone,
    row.carrier.dotNumber ? `DOT ${row.carrier.dotNumber}` : null,
    row.carrier.mcNumber ? `MC ${row.carrier.mcNumber}` : null,
  ].filter(Boolean);

  return details.length
    ? `${row.carrier.companyName}, ${details.join(' · ')}`
    : row.carrier.companyName;
};

/**
 * The Carrier Rate cell. `deliveryFeeSnapshot` is cents on every status.
 *
 * This reader was always right; what was wrong was approve writing dollars
 * into the same column, which made an approved load's $125 rate render as
 * $1.25. Settled by the 20260813 backfill — see approveOrderItem.ts.
 */
export const carrierRateCell = (row: { deliveryFeeSnapshot?: number | null }): string | null => {
  if (!row.deliveryFeeSnapshot || row.deliveryFeeSnapshot === 0) {
    return null;
  }

  return formatMoney(row.deliveryFeeSnapshot / 100);
};
